import React from "react";
import { Box } from "@chakra-ui/react";
import utils from "../utils";
import { CustomizedAlert } from "./CustomizedAlert";
import { CodeViewer } from "./CodeViewer";

export const TextItemNode = (props) => {
  let contentSegment = null;

  switch (props.format.toLowerCase()) {
    case "none": {
      contentSegment = (
        <Box
          dangerouslySetInnerHTML={{
            __html: utils.formatDisplayText(props.content),
          }}
        ></Box>
      );
      break;
    }
    case "tip": {
      contentSegment = <CustomizedAlert status="info" text={props.content} />;
      break;
    }
    case "note": {
      contentSegment = (
        <CustomizedAlert status="warning" text={props.content} />
      );
      break;
    }
    case "warning": {
      contentSegment = <CustomizedAlert status="error" text={props.content} />;
      break;
    }
    case "raw": {
      contentSegment = (
        <Box borderColor="gray" rounded="md" borderWidth="1px" padding={3}>
          <pre
            dangerouslySetInnerHTML={{
              __html: props.content,
            }}
          ></pre>
        </Box>
      );
      break;
    }
    case "code": {
      contentSegment = (
        <Box borderColor="gray" rounded="md" borderWidth="1px" padding={1}>
          <CodeViewer code={props.content} />
        </Box>
      );
      break;
    }
    default: {
      break;
    }
  }

  return contentSegment !== null ? contentSegment : "";
};
